export class ApiConfig {
  /**
   * @param {{
   * getItems: Function,
   * getItem: Function,
   * createItem: Function,
   * updateItem: Function,
   * deleteItem: Function,
   * getNestedList: Function,
   * }} api
   * @param {{
   * CreateModalComponent?: null,
   * titleFieldName?: string,
   * idFieldName?: string
   * }} config
   */
  constructor (api, { CreateModalComponent = null, titleFieldName = 'name', idFieldName = 'id' } = {}) {
    const apiConfig = {
      ...api,
      CreateModalComponent,
      titleFieldName,
      idFieldName
    }
    for (const key in apiConfig) {
      this[key] = apiConfig[key]
    }
  }
}
export class ApiFactory {
  create (entityName) {
    switch (entityName) {
      default:
        return new ApiConfig()
    }
  }
}
